<footer class=" border-t border-slate-200 pt-6 mt-0">
  <div class="flex flex-auto align-center  items-center container">
    <div class="flex flex-auto justify-start gap-10 items-center">
      <div>
        <h4> Delivering Amazing Technology </h4>
        <span>©Copyright 2025 ZdsLogic LLC </span>
        <a href="http://www.zdslogic.com/privacy">Privacy Policy</a>
      </div>

      <div>Powered by ZdsLogic
        <a href="">
          <img src="assets/images/zdslogic-seal.png" alt="ZdsLogic">
        </a>
      </div>

      <div id="right_content">
        <h4>
          <span>Since 2014</span>
        </h4>
        <span>All Rights Reserved</span>.<br /> <a href="http://www.zdslogic.com/contact"><span>Customer
            Service</span></a>
      </div>
    </div>
    <div class="flex">
    <!--  AddThis Button BEGIN  -->
      <div class="social_links flex flex-auto gap-6">
        <a class="externallink" target="_blank" rel="nofollow" href="https://twitter.com/zdslogic">
          <img src="assets/common/img/twitter-button.png" alt="ZdsLogic on Twitter"></a>
        <a class="externallink" target="_blank" rel="nofollow" href="https://facebook.com/zdslogic">
          <img src="assets/common/img/facebook-button.png" alt="ZdsLogic on Facebook"></a>
        <a class="externallink" target="_blank" rel="nofollow"
          href="https://www.linkedin.com/company/zdslogic">
          <img src="assets/common/img/linked-in-button.png" alt="ZdsLogic on LinkedIn"></a>
        <a class="externallink" target="_blank" rel="nofollow"
          href="https://www.alignable.com/little-compton-ri/zdslogic-technologies">
          <img src="assets/common/img/alignable-button.png" alt="ZdsLogic on Alignable"></a>	    
      </div>

      <div id="_atssh" style="visibility: hidden; height: 1px; width: 1px; position: absolute; z-index: 100000;">
        <iframe id="_atssh739" title="AddThis utility frame"
          style="height: 1px; width: 1px; position: absolute; z-index: 100000; border: 0px; left: 0px; top: 0px;"
          src="//s7.addthis.com/static/r07/sh155.html#iit=1396900919590&tmr=load%3D1396900919569%26core%3D1396900919587%26main%3D1396900919588%26ifr%3D1396900919593&cb=0&cdn=0&chr=UTF-8&kw=Technology%2CZdsLogic%2COpen%20Source%2CGeo%2CGeoServer%2CEclipse%2CJava%2CJEE%2CBIRT%2COSGi%2CSoftware%2CDeveloper%2CArchitect%2CSoftware%20Developer%2CSoftware%20Development%2CSoftware%20Architecture%2CJSP%2CJTA%2CSOA%2CRich%20Client&ab=-&dh=www.zdslogic.com&dr=&du=http%3A%2F%2Fwww.zdslogic.com%2F&dt=ZdsLogic%20Technologies&dbg=0&md=0&cap=tc%3D0%26ab%3D1&inst=1&vcl=0&jsl=33&prod=undefined&lng=en&ogt=&pc=men&pub=ra-53382bff4c2e420c&ssl=0&sid=5343043702b3f33c&srpl=1&srcs=1&srd=1&srf=1&srx=1&ver=300&xck=0&xtr=0&og=&aa=0&rev=127218&ct=1&xld=1&xd=1"></iframe>
      </div>

    </div>
  </div>
</footer>